<template>
	<div class="text-widget-field">
		<default-widget-field v-bind="defaultFieldProps" v-on="defaultFieldListeners" />
		<div>
			<v-text-field
				:ref="fieldRef"
				v-model="value"
				v-if="!isLongText"
				data-lpignore="true"
				class="widget-input-field widget-text-field-layout"
				:placeholder="placeholder"
				v-bind="activeFormFieldCommonProps"
			></v-text-field>
			<v-textarea
				v-else
				class="widget-input-field"
				v-model="value"
				data-lpignore="true"
				:placeholder="placeholder"
				v-bind="activeFormFieldCommonProps"
				solo
				rows="4"
			>
			</v-textarea>
		</div>
	</div>
</template>

<script>
import DefaultWidgetField from './DefaultWidgetField';
import WidgetFieldMixin from './WidgetFieldMixin';

export default {
	name: 'TextInputField',
	components: {
		DefaultWidgetField,
	},
	mixins: [WidgetFieldMixin],
	computed: {
		isLongText() {
			try {
				return this.field.metadata.options.longText.enabled;
			} catch (err) {
				return false;
			}
		},
		placeholder() {
			if (!this.field.metadata.options.placeholder.enabled) {
				return '';
			}
			return this.field.metadata.options.placeholder.value;
		},
	},
};
</script>

<style scoped lang="scss">
.selected-input {
	::v-deep {
		&:focus {
			background-color: #f5f8fe;
		}
	}
}
.text-widget-field {
	::v-deep(input:-webkit-autofill) {
		// remove chrome blue background on autocomplete input
		&,
		&:hover,
		&:focus,
		&:active {
			-webkit-box-shadow: 0 0 0 30px white inset !important;
		}
	}
	::v-deep(.v-text-field--outlined > .v-input__control > .v-input__slot fieldset) {
		min-height: 30px;
		border-radius: 4px;
	}
}
</style>
